// extracted by mini-css-extract-plugin
export default {"right":"right_right__ZU-eE","top":"right_top__btjWI","bottom":"right_bottom__k2hWJ"};